import { render, staticRenderFns } from "./BankAddressBookModal.vue?vue&type=template&id=06599dd2&scoped=true&"
import script from "./BankAddressBookModal.vue?vue&type=script&lang=js&"
export * from "./BankAddressBookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06599dd2",
  null
  
)

export default component.exports